// HowMatchingWorks — explains the real, non-black-box logic behind the
// project-relevance indicator shown on Ecosystem cards (Story: Ecosystem
// Marketplace project-domain-overlap matching).
import ContextualTip from '../ui/ContextualTip'

export default function HowMatchingWorks() {
  return (
    <ContextualTip id="ecosystem-how-matching-works" tone="info">
      <strong>How matching works:</strong> we compare each profile's listed domains
      against the technical vertical of your active projects. The indicator shows the
      real overlap — the shared domains, and how many of your projects each partner is
      relevant to. When you filter by a specific project, we also show a live
      embedding-similarity percentage computed from that project's documents. No hidden
      scoring — profiles with no real overlap simply show no relevance number.
    </ContextualTip>
  )
}
